import React from 'react'
import { MenuLogo } from './menu-logo'
import { MenuShelfOptions, MenuShelfOptionsProps } from './menu-shelf-options'
import { MenuShelfConfiguration, MenuShelfConfigurationProps } from './menu-shelf-configuration/menu-shelf-configuration'
import { MenuShareAndCart, MenuShareAndCartProps } from './menu-share-and-cart'

interface MenuProps extends MenuShelfOptionsProps, MenuShelfConfigurationProps, MenuShareAndCartProps {}

export const Menu = (props: MenuProps) => {
	return (
		<div className='flex flex-col w-64'>
			<div className='flex flex-col h-0 flex-1 border-r border-gray-200 bg-white'>
				<div className='flex-1 flex flex-col pt-5 pb-4 overflow-y-auto'>
					<MenuLogo />
					<MenuShelfOptions addShelf={props.addShelf} />
					<MenuShelfConfiguration
						toggleBackVisibility={props.toggleBackVisibility}
						toggleDoorVisibility={props.toggleDoorVisibility}
						toggleShelfVisibility={props.toggleShelfVisibility}
						toggleCrossDivider={props.toggleCrossDivider}
						toggleCornerDirection={props.toggleCornerDirection}
						toggleTopDrawerVisibility={props.toggleTopDrawerVisibility}
						toggleMiddleDrawerVisibility={props.toggleMiddleDrawerVisibility}
						toggleBottomDrawerVisibility={props.toggleBottomDrawerVisibility}
						deleteShelf={props.deleteShelf}
					/>
				</div>
				<MenuShareAndCart shareLinkCopied={props.shareLinkCopied} viewCart={props.viewCart} />
			</div>
		</div>
	)
}
